import Cookies from 'js-cookie';

import { getSessionCookie, getSitecoreCookie, getSitecoreCookieDomain } from '@shared/configs/configs/config';
import { LOGOUT_PATH, ROOT_PATH } from '@shared/constants/paths';

const clearCookies = () => {
  Cookies.remove(getSitecoreCookie(), { path: ROOT_PATH, domain: getSitecoreCookieDomain() });
  Cookies.remove(getSessionCookie(), { path: LOGOUT_PATH });
};

export { clearCookies };
